// This dictionary contains 1 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.
import { localization } from "../localizationManager";

export var frenchStrings = {
  groupButton: "Grouper",
  ungroupButton: "Dissocier",
  selectButton: "Sélectionner",
  hideColumn: "Masquer colonne",
  showColumn: "Afficher colonne",
  makePrivateColumn: "Rendre la colonne privé",
  makePublicColumn: "Rendre la colonne public",
  moveToDetail: "Déplacer vers détails",
  showAsColumn: "Afficher en colonne",
  filterPlaceholder: "Rechercher...",
  removeRows: "Supprimer colonne",
  showLabel: "Afficher",
  entriesLabel: "entrées",
  visualizer_text: "Textes en table",
  visualizer_wordcloud: "Nuages de mots",
  visualizer_histogram: "Histogramme",
  visualizer_number: "Moyenne",
  visualizer_choices: "Table",
  visualizer_selectBase: "Graphique",
  // visualizer_matrix: "Chart",
  chartType_bar: "Barres",
  chartType_vbar: "Barre verticale",
  chartType_stackedbar: "Barres empilées",
  chartType_doughnut: "Anneau",
  chartType_pie: "Secteurs",
  chartType_scatter: "Nuages de points",
  chartType_gauge: "Gauge",
  chartType_bullet: "Bulles",
  hideButton: "Masquer",
  makePrivateButton: "Rendre privé",
  makePublicButton: "Rendre publique",
  showButton: "Afficher",
  filter: "Filtre",
  resetFilter: "Rafraichir Filtres",
  changeLocale: "Changer les paramètres régionaux",
  clearButton: "Rafraichir",
  addElement: "Choisir la question à afficher...",
  defaultOrder: "Defaut",
  ascOrder: "Ascendant",
  descOrder: "Descendant",
  showMinorColumns: "Afficher les colonnes mineures",
  otherCommentTitle: "Autre élément et commentaires",
  showPercentages: "Afficher les pourcentages",
  hidePercentages: "Masquer les pourcentages",
  pdfDownloadCaption: "PDF",
  xlsxDownloadCaption: "Exceller",
  csvDownloadCaption: "Fichier CSV",
  saveDiagramAsPNG: "Sauver en png",
  hideEmptyAnswers: "Masquer les réponses vides",
  showEmptyAnswers: "Afficher les réponses vides",
  "topNValueText-1": "Toutes les réponses",
  topNValueText5: "Top 5 des réponses",
  topNValueText10: "Top 10 des réponses",
  topNValueText20: "Top 20 des réponses",
  hideMissingAnswers: "Masquer les réponses manquantes",
  showMissingAnswers: "Afficher les réponses manquantes",
  missingAnswersLabel: "Réponses manquantes",
  noVisualizerForQuestion: "Ce type de question n'est pas encore visualisé",
  noResults: "Il n'y a pas encore de résultats",
  showPerValues: "Par valeur",
  showPerColumns: "Par colonne",
  answer: "Réponse",
  correctAnswer: "Réponse correcte: ",
  percent: "Pourcentage",
  responses: "Réponses"
};

localization.locales["fr"] = frenchStrings;
localization.localeNames["fr"] = "Français";

// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// undefined.visualizer_histogram: "Histogram" => "Histogramme"
// undefined.visualizer_number: "Average" => "Moyenne"
// undefined.visualizer_choices: "Table" => "Table"
// undefined.visualizer_selectBase: "Chart" => "Graphique"
// undefined.chartType_vbar: "Vertical Bar" => "Barre verticale"
// undefined.changeLocale: "Change Locale" => "Changer les paramètres régionaux"
// undefined.showPercentages: "Show percentages" => "Afficher les pourcentages"
// undefined.hidePercentages: "Hide percentages" => "Masquer les pourcentages"
// undefined.pdfDownloadCaption: "PDF" => "PDF"
// undefined.xlsxDownloadCaption: "Excel" => "Exceller"
// undefined.csvDownloadCaption: "CSV" => "Fichier CSV"
// undefined.hideEmptyAnswers: "Hide empty answers" => "Masquer les réponses vides"
// undefined.showEmptyAnswers: "Show empty answers" => "Afficher les réponses vides"
// undefined.topNValueText-1: "All answers" => "Toutes les réponses"
// undefined.topNValueText5: "Top 5 answers" => "Top 5 des réponses"
// undefined.topNValueText10: "Top 10 answers" => "Top 10 des réponses"
// undefined.topNValueText20: "Top 20 answers" => "Top 20 des réponses"
// undefined.hideMissingAnswers: "Hide missing answers" => "Masquer les réponses manquantes"
// undefined.showMissingAnswers: "Show missing answers" => "Afficher les réponses manquantes"
// undefined.missingAnswersLabel: "Missing answers" => "Réponses manquantes"